import { Alert, Button, Col, Flex, Row, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import PageTitle from '../../components/PageTitle'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectSelectedProfile } from '../../store/ProfileReducer'
import { Actions } from '../../modules/sbrm/components/Actions'
import { SBRMType } from '../../modules/sbrm/SBRMModel'
import { useNavigate } from 'react-router-dom'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { Subscription } from '../../components/subscription/Subscription'

const SettingsPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const { isOpen: SBRMIsOpen } = useAppSelector((state) => state.SBRM)
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)
  const profile = useAppSelector(selectSelectedProfile())

  useEffect(() => {
    if (!isFirstRender && SBRMIsOpen) {
      return
    }
    setIsFirstRender(false)
    if (!profile) {
      navigate('/profiles')
    }
  }, [dispatch, SBRMIsOpen, profile])

  if (!profile) {
    return <Skeleton loading />
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Flex vertical gap={10}>
          <PageTitle
            type="sympa"
            title={i18n.t(LocalizationKeys.Page.ProfileSettingsPage.Title)}
          />
          <PageTitle
            title={i18n.t(
              LocalizationKeys.Page.ProfileSettingsPage.PlanAndBilling
            )}
            level={5}
          />
          <Row
            gutter={[16, 16]}
            style={{
              justifyContent: 'space-between',
            }}
          >
            <Col xs={24} md={24} lg={16} style={{ boxSizing: 'border-box' }}>
              <Subscription.SummaryCard profile={profile} />
            </Col>
            <Col xs={24} md={24} lg={8} style={{ boxSizing: 'border-box' }}>
              <Subscription.InvoicesCard profile={profile} />
            </Col>
          </Row>
        </Flex>
      </Col>
      <Col span={2024}>
        <Flex vertical gap={10}>
          <PageTitle
            title={i18n.t(LocalizationKeys.Page.ProfileSettingsPage.DangerZone)}
            level={5}
          />
          <Alert
            style={{ alignItems: 'center', gap: 10 }}
            description={i18n.t(
              LocalizationKeys.Page.ProfileSettingsPage.DeleteExplanation
            )}
            message={i18n.t(
              LocalizationKeys.Page.ProfileSettingsPage.DeleteProfil
            )}
            showIcon
            type="error"
            action={
              <Actions
                actions={['delete']}
                entity={SBRMType.profile}
                entityId={profile.id}
                trigger={
                  <Button danger>
                    {i18n.t(
                      LocalizationKeys.Page.ProfileSettingsPage.DeleteButton
                    )}
                  </Button>
                }
              />
            }
          />
        </Flex>
      </Col>
    </Row>
  )
}

export default SettingsPage
